<template>
  <v-select
    v-model="c_types"
    :items="rate_types"
    offset-y
    label="Tip Tarif"
    class="ma-1"
    :loading="loading"
    hide-details dense outlined multiple chips small-chips deletable-chips
  />
</template>


<script>

  import config_repository from '@/repositories/config-repository'

  export default {

    props: {
      types: Array
    },

    computed: {
      c_types: {
        get() {
          return this.types;
        },
        set(val) {
          this.$emit("update:types", val);
        }
      }
    },

    data: () => ({
      rate_types: [],
      loading: false
    }),

    async created() {
      await this.getRateTypes()
    },

    methods: {
      async getRateTypes() {
        try {
          this.loading = true;
          this.rate_types = await config_repository.getRateTypes();
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.loading = false;
        }
      }
    }

  }
</script>